var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterCenterFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM15 3H19C20.1 3 21 3.9 21 5V9H19V5H15V3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19ZM9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCenterFocus);
export default __webpack_public_path__ + "static/media/filter_center_focus.1e23ada9afff7ac547a93e71f509cfbb.svg";
export { ForwardRef as ReactComponent };